const state = {
  draftID: null,
  AllForms: [],
  multipleForms: {},
  formSearchKey: "",
  AllSubmits: [],
  clients: [],
  postcodeQuery: null,
  formsuccess: false,
  leadforced: false,
  checkZiggo: null,
  checkYoufone: null,
  checkTmobile: null,
  checkKpn: null,
  disciplinecode: null,
  supplierdata: [],
  customizedOffers: [],
  nationalities: [],
  itemIsShow: [],
  overview: [],
  lang: "en",
  edit: false,
  ratesloader: false,
  number_addition: null,
  trigger: false,
  languages: {
    en: "English",
    nl: "Dutch"
  },
  defaultDurations: [],
  rates: [],
  formStateData: {},
  FormTwoAdded: 0,
  postcode: {
    numberAddition: null
  },
  modalContentAsComputed: {
    title: null,
    description: null
  },
  filterMetrics: [
    { type: 1, metrics: ["businessresidence", "residence"] },
    { type: 2, metrics: ["businessresidence", "businessonly"] }
  ],
  mortgage: {},
  addressResidential : true,

  //new
  enums: {
    electricity: {
      value: 1,
      estimated: false,
      showSupplier: true,
      showCategory: true,
      subtitle4Supplier: "choosesupplier",
      info: false
    },
    gas: {
      value: 2,
      estimated: false,
      showSupplier: true,
      showCategory: true,
      subtitle4Supplier: "choosesupplier",
      info: false
    },
    internet: {
      value: 4,
      suppliers: {
        ziggo: 1,
        kpn: 3,
        tMobile: 11,
        youfone: 57
      },
      estimated: false,
      showSupplier: true,
      showCategory: true,
      subtitle4Supplier: "choosesupplier",
      info: false
    },
    water: {
      value: 3,
      estimated: true,
      showSupplier: true,
      showCategory: true,
      subtitle4Supplier: "choosesupplier",
      info: false
    },
    cityheat: {
      value: 7,
      estimated: true,
      showSupplier: true,
      showCategory: true,
      subtitle4Supplier: "choosesupplier",
      info: false
    },
    insurance: {
      value: 10,
      showSupplier: false,
      showCategory: false,
      estimated: true,
      subtitle4Supplier: "chooseinsurance",
      info: true
    },
    mobile: {
      value: 8,
      estimated: false,
      showSupplier: true,
      showCategory: true,
      subtitle4Supplier: "choosesupplier",
      info: false
    },
    bankaccount: {
      value: 9,
      estimated: false,
      showSupplier: true,
      showCategory: true,
      subtitle4Supplier: "choosebankaccount",
      info: true
    },
    hypotheek: {
      value: 10,
      estimated: true,
      showSupplier: true,
      showCategory: true,
      subtitle4Supplier: "hypotheek",
      info: true
    }
  },

  languageEnum: {
    nl: 1,
    en: 2
  },

  //done
  insuranceSelectionsLead: [],
  meter: "1",
  smartMeter : "0",
  startDateStatus: "0",
  generalDate: new Date(),
  lookUpDate: [],
  electricGasDate: null,
  solar: {
    status: "2",
    kwhKnown: "2",
    number_of_panels: 0,
    low: "0",
    high: "0",
    single: "0"
  },
  consumption: {
    status: "2",
    familySituation: 1,
    electric: {
      single: "1450",
      low: "580",
      high : "870",
      net: "1450",
      double: {
        low: "580",
        high: "870"
      }
    },
    gas: "920",
    water: {
      m3_monthly: "0",
      monthly_price: "0",
      yearly_price: "0"
    },
    stadswarmte: {
      m3_monthly: "0",
      monthly_price: "0",
      yearly_price: "0"
    }
  },
  solars: [],
  pricing: {
    energy_total: 0,
    gas_total: 0
  },
  consumptions: [],
  //static
  combinations: {
    gas: {
      widgets: [5],
      supplier: 1,
      supplierCheck: 0,
      duration: 1,
      customizedoffer: 1,
      consumption: 1,
      solar: 0,
      customerTypeFilter: 1
    },
    electricity: {
      widgets: [6],
      supplier: 1,
      supplierCheck: 0,
      duration: 1,
      customizedoffer: 1,
      consumption: 1,
      solar: 1,
      customerTypeFilter: 1
    },
    electricityandgas: {
      supplierCheck: 0,
      customerTypeFilter: 1
    },
    internet: {
      widgets: null,
      supplier: 1,
      supplierCheck: 1,
      duration: 1,
      customizedoffer: 0,
      consumption: 0,
      solar: 0,
      customerTypeFilter: 0
    },
    mobile: {
      widgets: null,
      supplier: 1,
      supplierCheck: 0,
      duration: 1,
      customizedoffer: 0,
      consumption: 0,
      solar: 0,
      customerTypeFilter: 1
    },
    water: {
      widgets: null,
      supplier: 0,
      supplierCheck: 0,
      duration: 0,
      customizedoffer: 0,
      consumption: 0,
      solar: 0,
      customerTypeFilter: 0
    },
    stadswarmte: {
      widgets: null,
      supplier: 0,
      supplierCheck: 0,
      duration: 0,
      customizedoffer: 0,
      consumption: 0,
      solar: 0,
      customerTypeFilter: 0
    },
    insurance: {
      widgets: null,
      supplier: 1,
      supplierCheck: 0,
      duration: 0,
      customizedoffer: 0,
      consumption: 0,
      solar: 0,
      customerTypeFilter: 0
    },
    bankaccount: {
      widgets: null,
      supplier: 1,
      supplierCheck: 0,
      duration: 1,
      customizedoffer: 0,
      consumption: 0,
      solar: 0,
      customerTypeFilter: 0
    }
  },
  durations: [
    {
      name: {
        nl: "Toon alles",
        en: "All"
      },
      rate_period_id: 0
    },
    {
      name: {
        nl: "Variabel",
        en: "Variabel"
      },
      rate_period_id: 8
    },
    {
      name: {
        nl: "Variabel / Maandelijks opzegbaar",
        en: "Monthly terminable"
      },
      rate_period_id: 1
    },
    {
      name: {
        nl: "1 jaar",
        en: "1 year"
      },
      rate_period_id: 2
    },
    {
      name: {
        nl: "2 jaar",
        en: "2 year"
      },
      rate_period_id: 7
    },
    {
      name: {
        nl: "3 jaar",
        en: "3 year"
      },
      rate_period_id: 3
    },
    {
      name: {
        nl: "4 jaar",
        en: "4 year"
      },
      rate_period_id: 6
    },
    {
      name: {
        nl: "5 jaar",
        en: "5 year"
      },
      rate_period_id: 4
    }
  ],
  SubmitData: {
    widgets: {
      address: {}
    },
    products: {}
  }
};

export default state;
